import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Lightweight, unauthenticated community-branding lookup for login screens.
 * Returns { community, brand_color, has_logo, logo_ver, mgmt_name } or null.
 * Branding is purely cosmetic — it never grants access (that stays membership/roster driven).
 */
export function useCommunityBrand(slug) {
  const [brand, setBrand] = useState(null);
  useEffect(() => {
    if (!slug) { setBrand(null); return; }
    let live = true;
    axios.get(`${API}/public/site/${slug}/brand`)
      .then((r) => { if (live) setBrand(r.data); })
      .catch(() => { if (live) setBrand(null); });
    return () => { live = false; };
  }, [slug]);
  return brand;
}
